import * as React from "react";
const SvgInfo20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2ZM0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9Zm10.25-3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 13.5v-5H8v5h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgInfo20Px;
